import BpkText, {
  TEXT_COLORS,
  TEXT_STYLES,
} from '@skyscanner/backpack-web/bpk-component-text';

import STYLES from '../CheckInCheckOut.module.scss';

const CheckInCheckOutDisplay = ({
  checkInCheckOutTime,
  stayDes,
}: {
  checkInCheckOutTime: string;
  stayDes: string;
}) => (
  <div>
    <BpkText
      tagName="p"
      textStyle={TEXT_STYLES.subheading}
      className={STYLES.CheckInCheckOut__text}
      color={TEXT_COLORS.textPrimary}
    >
      {stayDes}
    </BpkText>
    <BpkText
      tagName="p"
      textStyle={TEXT_STYLES.subheading}
      className={STYLES.CheckInCheckOut__time}
    >
      {checkInCheckOutTime}
    </BpkText>
  </div>
);

export default CheckInCheckOutDisplay;
